import { render, staticRenderFns } from "./integracoes.vue?vue&type=template&id=0a19c739&scoped=true&"
import script from "./integracoes.vue?vue&type=script&lang=js&"
export * from "./integracoes.vue?vue&type=script&lang=js&"
import style0 from "./integracoes.vue?vue&type=style&index=0&id=0a19c739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a19c739",
  null
  
)

export default component.exports